import React, { Component } from 'react';
import moment from 'moment';
import NumberFormat from 'react-number-format';

const CURRENT_STEP = 'PATIENT_INFORMATION';

class PatientInformation extends Component {
  constructor(props) {
    super(props);

    this.state = { errors: [] }

    this.validate = this.validate.bind(this);
  }

  validate(evt) {
    evt.preventDefault()

    let errors = {};
    let phoneNumber = this.props.cellPhoneNumber.replace(/\D/g, '');

    if (this.props.firstName.length === 0) {
      errors.firstName = 'First name is required.'
    }

    if (this.props.lastName.length === 0) {
      errors.lastName = 'Last name is required.'
    }

    if (phoneNumber.length === 0 && this.props.email === "") {
      errors.phoneNumber = 'Cell Phone Number or Email is required.';
      errors.email = 'Cell Phone Number or Email is required.';
    }

    if (phoneNumber !== "" && phoneNumber.length !== 10) {
      errors.phoneNumber = 'Invalid format: Ex: 9091236789.';
    }

    if (this.props.email !== "" && (!this.props.email.includes('@') || !this.props.email.includes('.'))) {
      errors.email = 'Invalid format: Ex: name@email.com';
    }

    if (this.props.dateOfBirth.length === 0) {
      errors.dateOfBirth = 'Date of Birth is required';
    } else if (this.props.dateOfBirth.replace(/\D/g, '').length !== 8) {
      errors.dateOfBirth = 'Invalid format: Ex: 03/15/1980.';
    } else if (!moment(this.props.dateOfBirth, 'MM/DD/YYYY').isValid()) {
      errors.dateOfBirth = 'Date of Birth is not valid.';
    }

    this.setState({ errors });

    if (!errors.firstName && !errors.lastName && !errors.phoneNumber && !errors.dateOfBirth && !errors.email) {
      this.props.nextStep();
    }
  }

  renderValidateMessage(field) {
    const message = this.state.errors[field];

    return (
      <div id={`${field}-error`} className="text-danger hide">{message}</div>
    );
  }

  render() {
    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    const { setValue } = this.props;

    return (
      <div className="card axs-shadow">
        <div className="card-body">
          <h3>Schedule Event</h3>
          <hr />

          <div className="alert alert-primary my-4" role="alert">
            Start by entering the patient's information.
          </div>

          <h6>Patient Information</h6>

          <form className="mt-4">
            <div className="form-group">
              <div className="row">
                <div className="col-sm-4">
                  <label><span className="text-danger">*</span> First Name</label>
                  <input
                    onChange={(e) => setValue('firstName', e.target.value)}
                    value={this.props.firstName}
                    name="firstName" type="text" className="form-control" placeholder="First Name" />
                  {this.renderValidateMessage('firstName')}
                </div>
                <div className="col-sm-4">
                  <label><span className="text-danger">*</span> Last Name</label>
                  <input
                    onChange={(e) => setValue('lastName', e.target.value)}
                    value={this.props.lastName}
                    name="lastName" type="text" className="form-control" placeholder="Last Name" />
                  {this.renderValidateMessage('lastName')}
                </div>
                <div className="col-sm-4">
                  <label><span className="text-danger">*</span> Date of Birth</label>
                  <NumberFormat
                    onValueChange={(e) => setValue('dateOfBirth', e.formattedValue)}
                    value={this.props.dateOfBirth}
                    format="##/##/####"
                    mask="_"
                    name="dateOfBirth"
                    className="form-control"
                    placeholder="__/__/____"
                  />
                  {this.renderValidateMessage('dateOfBirth')}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 form-group">
                <label><span className="text-danger">*</span> Cell Phone Number</label>
                <NumberFormat
                  onValueChange={(e) => setValue('cellPhoneNumber', e.value)}
                  value={this.props.cellPhoneNumber}
                  format="###-###-####"
                  mask="_"
                  name="phoneNumber"
                  className="form-control"
                  placeholder="___-___-____"
                />
                <small>Required if an email address is not entered</small>
                {this.renderValidateMessage('phoneNumber')}
              </div>

              <div className="col-sm-4">
                <label><span className="text-danger">*</span> Email Address</label>
                <input
                  onChange={(e) => setValue('email', e.target.value)}
                  value={this.props.email}
                  name="email" type="text" className="form-control" placeholder="Enter Email" />
                <small>Required if a phone number is not entered</small>
                {this.renderValidateMessage('email')}
              </div>
            </div>

            <div className="row">
              <div className="col-sm-4">
                <label>Chart ID</label>
                <input
                  onChange={(e) => setValue('chartId', e.target.value)}
                  value={this.props.chartId}
                  name="chartId"
                  type="text"
                  className="form-control"
                  placeholder="Chart ID"
                />
              </div>
              <div className="col-sm-4">
                <label>Other Chart ID</label>
                <input
                  onChange={(e) => setValue('otherId', e.target.value)}
                  value={this.props.otherId}
                  name="otherId"
                  type="text"
                  className="form-control"
                  placeholder="Other ID"
                />
              </div>
            </div>
          </form>
        </div>
        <div className="card-footer">
          <div className="row text-right">
            <div className="col-sm-4">
              <button
                onClick={this.validate}
                type="submit" className="btn btn-primary btn-block">Next</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PatientInformation;